<ion-content *ngIf="apptTimeEntries">
	<ng-container *ngIf="apptTimeEntries.length > 0; else empty">
		<ng-container
			*ngFor="let apptTimeEntry of apptTimeEntries; index as index"
		>
			<ion-item-group *ngIf="apptTimeEntry.entries?.length > 0">
				<ion-item
					lines="full"
					button
					mode="md"
					(click)="onClickToggleSection(index)"
				>
					<div class="header-section" slot="end">
						<ion-text class="toggle-text">
							{{ getAppointmentTimeEntryTime(apptTimeEntry) }}
						</ion-text>
						<ion-icon
							class="toggle-arrow"
							size="small"
							[name]="
								isVisible(index)
									? 'chevron-up-outline'
									: 'chevron-down-outline'
							"
						></ion-icon>
					</div>
					<ion-text>
						{{ apptTimeEntry.displayValue }}
					</ion-text>
				</ion-item>
				<ion-list *ngIf="isVisible(index)" class="time-entries">
					<app-time-entry-toggle-section
						*ngFor="let timeEntry of apptTimeEntry.entries"
						[timeEntry]="timeEntry"
						[apptTimeEntry]="apptTimeEntry"
						[techId]="techId"
						[DisableEditOnCleared]="DisableEditOnCleared"
						(changed)="setTimeEntries()"
					></app-time-entry-toggle-section>
				</ion-list>
			</ion-item-group>
		</ng-container>
	</ng-container>

	<ng-template #empty>
		<app-empty-list-item
			message="No time entries for today"
		></app-empty-list-item>
	</ng-template>
</ion-content>

<ion-footer>
	<app-titled-add-toolbar
		*ngIf="apptTimeEntries"
		[title]="'Total Time Today: ' + getTotalTimeToday()"
		(clickedAdd)="onClickAddTimeEntry()"
	></app-titled-add-toolbar>
</ion-footer>
